import { Injectable } from '@angular/core';
import { fromEvent, merge } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class PreventPinchZoomService {
  init() {
    merge(
      fromEvent(document, 'gesturestart'),
      fromEvent(document, 'gesturechange'),
      fromEvent(document, 'gestureend'),
    )
      .pipe(
        tap((event) => {
          event.preventDefault();
          document.body.style.zoom = String(0.99);
        }),
      )
      .subscribe();
  }
}
